import React from 'react'
import { SvgIcon } from '@mui/material'

export const SentStatusIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M7.5 14.42v.08l8.33-8.42-1-1.08-7.33 7.33-3.08-3.08-1.09 1.08 4.17 4.09Z"
      fill="#818181"
    />
  </SvgIcon>
)
